import React from 'react';
import cx from 'classnames';
import {Link, Icon, svgs, Message} from 'epic-diesel-common';
import {formatDateDiffByLocale} from '../../../utils/Utils';

//@ts-ignore
import styles from './NewsItem.pcss';

export interface Props {
    shareImage?: string;
    trendingImage?: string;
    trendingImageAlt?: string;
    date: string;
    title: string;
    slug?: string;
    url: string;
    tags?: string;
    cat?: string;
    sticky: boolean;
    externalLink?: string;
    urlPattern?: string;
    index?: number;
    locale?: string;
    onClick?: VoidFunction;
}

const CODES = {
    ctaLabel: 'epic.affiliate.news.readMore'
};

const NewsItem: React.FC<Props> = props => {
    const {
        shareImage,
        trendingImage,
        trendingImageAlt,
        date,
        title,
        slug,
        url,
        cat = '',
        sticky,
        externalLink,
        locale,
        onClick
    } = props;

    const image = shareImage || trendingImage;
    const catArr = cat.split(',');
    const linkUrl = externalLink ? `${externalLink}?lang=${locale}` : url;

    return (
        <li className={styles.item}>
            <Link
                to={linkUrl}
                className={styles.link}
                ariaLabelledby={slug}
                dontIncludeLocale
                onClick={onClick}>
                <div className={cx(styles.imageWrapper, {[styles.placeholder]: !image})}>
                    {image ? (
                        <img src={image} className={styles.image} alt={trendingImageAlt} />
                    ) : (
                        <Icon icon={svgs.EPIC} fontSize="large" className={styles.image} />
                    )}
                </div>

                <div className={styles.header}>
                    <div className={styles.newsMeta}>
                        {sticky && (
                            <Icon icon={svgs.STAR} fontSize="small" className={styles.stickyIcon} />
                        )}

                        <span className={styles.date}>{formatDateDiffByLocale(date, locale)}</span>

                        {catArr.length > 0 && (
                            <ul className={styles.catTags}>
                                {catArr.map(cat => (
                                    <li key={cat} className={styles.catTag} id={slug}>
                                        <span>{cat}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <h2>{title}</h2>
                    <div className={styles.cta}>
                        <span className={styles.ctaLabel}>
                            <Message code={CODES.ctaLabel} />
                            {externalLink && (
                                <Icon
                                    icon={svgs.EXTERNAL_LINK}
                                    fontSize="small"
                                    className={styles.externalIcon}
                                />
                            )}
                        </span>
                    </div>
                </div>
            </Link>
        </li>
    );
};

export default React.memo(NewsItem);
